import React from 'react'

import styles from './Content.module.scss'

const ContentPharma = ({ maxWidth, fontSize, ...rest }) => (
  <div {...rest} className={styles.base} style={{ maxWidth, fontSize }} />
)

export default ContentPharma
